// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  max-width: 100%;
}

.main-content {
  background-color: #fff;
}

.css-1aofkba
  .flatpickr-calendar
  .flatpickr-innerContainer
  .flatpickr-rContainer
  .flatpickr-days
  .dayContainer {
  padding-right: 1.678em !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,iCAAiC;AACnC","sourcesContent":["body {\n  max-width: 100%;\n}\n\n.main-content {\n  background-color: #fff;\n}\n\n.css-1aofkba\n  .flatpickr-calendar\n  .flatpickr-innerContainer\n  .flatpickr-rContainer\n  .flatpickr-days\n  .dayContainer {\n  padding-right: 1.678em !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
